import styled from 'styled-components';

const NavIcon = styled.img`
  display: block;
  cursor: pointer;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  max-width: ${props => props.size}px;
  max-height: ${props => props.size}px;
  ${props => props.circular && 'border-radius: 50%;'};
`;

export default NavIcon;
